export const inputPreset = {
  inputtext: {
    root: {
      borderRadius: '0.5rem',
      paddingX: '0.75rem',
      paddingY: '0.5rem',
      fontSize: '0.875rem',
      background: '#FFFFFF',
      color: 'var(--neutral--80)',
      borderColor: 'var(--neutral--30)',
      focusBorderColor: 'var(--brand--50)',
      focusRing: {
        width: '3px',
        color: 'rgba(21, 93, 252, 0.12)',
        offset: '0rem',
        style: 'solid',
      },
      invalidBorderColor: '#dc2626',
      placeholderColor: 'var(--neutral--40)',
      disabledBackground: 'var(--neutral--10)',
      disabledColor: 'var(--neutral--50)',
    },
    css: () => `
      .error-msg {
        font-size: 13px;
        font-weight: 500;
        color: #dc2626;
      }
    `,
  },
};
